import { Button, FormControl, FormHelperText, MenuItem, Select } from '@material-ui/core';
import { useEffect, useRef } from 'react';
import { useState } from 'react';
import { connect } from 'react-redux';
import en from '../../../../lang/en-us';
import TextInput from '../../../../lib/TextField';
import { UploadFile } from '../../../../lib/UploadFile.tsx';
import { RootStateType } from '../../../../redux-store/reducers';
import { BANK, ImageSaveType } from '../../../../redux-store/types/nct';
import { ConsolidateTableRowType } from '../ConsolidationFolios/types';
import {
    sendPhoneOTP,
    fetchIFSCDetails,
    onSaveImageData,
} from '../../../../redux-store/actions/nct';
import {
    accountNumberRegex,
    accountNumberValidation,
    ACCOUNT_TYPE_MASTER_DATA,
    BANK_ACCOUNT_DETAILS,
    getBankAddress,
    ifscRegex,
    isAlphaNumeric,
    OTP_ACTIONS,
    TaxStatusRIArray,
    validateIfsc,
} from '../../../../utils/constants';
import { NoteModals } from '../../../../lib/NoteModals';
import { initialValues } from '../ChangeTaxStatus/change-bank-details';
import { ValidationUI } from '../MinorStatus/minor-status-edit-bank';
import { IfscModal } from '../../../../lib/NoteModals/ifscModal';
import { ActionHeader, FaqLink } from '..';
import { findDefaultBankIndex, findDefaultBank } from '../ChangeBank';
const { dashboard, common } = en;

interface BANK_ACCOUNT_DETAILS extends BANK {
    amcName: string;
    primaryHolder: string;
    folioNo?: string;
}

type ACCOUNT_DETAILS = {
    key: string;
    label: string;
    value: string;
    isDisabled?: boolean;
    blurFunction?: Function;
    fieldValidation?: Function;
    shouldValidateField?: boolean;
};

const getInitChequeData = () => {
    return {
        oldCheque: { name: 'OldCheque', format: '', content: '' },
        newCheque: { name: 'NewCheque', format: '', content: '' },
    };
};
function BankMandateAddBank(props: any) {
    const [bankDetails, setDetails] = useState<BANK_ACCOUNT_DETAILS[]>([]);
    const { targetFunds = [] } = props.location.state || {};

    const [newBankDetails, setNewDetails] = useState({
        accountNo: '',
        ifsc: '',
        name: '',
        accountType: 'SAVINGS',
        branch: '',
        city: '',
    });
    const [modalData, setShowModal] = useState<any>(initialValues);
    const [showLoader, setLoader] = useState<boolean>(false);
    const [ifscValidation, setValidation] = useState<boolean>(false);
    const [errors, setErrors] = useState<any>({});
    const [cheques, setCheques] = useState<any>(getInitChequeData());
    const [showAlertModal, setAlertModal] = useState<{ deleteType: string; showModal: boolean }>({
        deleteType: '',
        showModal: false,
    });
    const folioRef = useRef<string>();

    useEffect(() => {
        if (!targetFunds.length) {
            props.history.push('/');
            return;
        }
        setDetails(
            targetFunds.map((_ele: ConsolidateTableRowType) => {
                const validBankIndex = findDefaultBankIndex(_ele);
                return {
                    amcName: _ele.amcName,
                    primaryHolder: _ele.investorName,
                    folioNo: _ele.folio,
                    ..._ele.bank[validBankIndex],
                };
            }),
        );
    }, []);

    useEffect(() => {
        const { ifsc } = newBankDetails;
        setLoader(false);
        if (ifsc.length === 11) {
            document.getElementById('ifsc')?.blur();
            _getBankDetailsFromIFSC(ifsc);
        } else {
            setNewDetails({
                ...newBankDetails,
                name: '',
                branch: '',
                city: '',
            });
        }
    }, [newBankDetails.ifsc]);

    const handleRemoveBankDetails = () => {
        const filteredDetails = bankDetails.filter(
            (_ele: BANK_ACCOUNT_DETAILS, ind: number) => ind !== Number(folioRef.current),
        );
        setAlertModal({
            showModal: false,
            deleteType: '',
        });
        if (filteredDetails.length === 0) {
            setAlertModal({
                deleteType: 'deletedAllFolios',
                showModal: true,
            });
            return;
        }
        setDetails(filteredDetails);
    };

    const _handleTextInputChange = (key: string, value: any) => {
        setNewDetails({
            ...newBankDetails,
            [key]: value,
        });
    };

    const validateForm = () => {
        let errors: any = {};
        let validForm = true;
        if (!accountNumberRegex.test(newBankDetails.accountNo)) {
            validForm = false;
            errors['accountNo'] = common.errors.bankErrors.accountNo.regexError;
        }
        if (!newBankDetails.ifsc.match(ifscRegex)) {
            validForm = false;
            errors['ifsc'] = common.errors.bankErrors.ifsc.regex;
        }
        if (newBankDetails.accountType === dashboard.ChangeBank.selectedFolios.fields.accountType) {
            validForm = false;
            errors['accountType'] = common.errors.bankErrors.accountType;
        }
        setErrors(errors);
        return validForm;
    };

    const handleSubmit = async () => {
        if (validateForm()) {
            const { targetFunds, actionType, addBank } = props.location.state;
            const { pan, pekrn, mobile } = props;
            const sourceAccountNos = targetFunds
                .map((_ele: ConsolidateTableRowType) => findDefaultBank(_ele)?.accountNo)
                .filter((accountNo: string | undefined) => accountNo);
            const sourceIFSCs = targetFunds
                .map((_ele: ConsolidateTableRowType) => findDefaultBank(_ele)?.ifsc?.toUpperCase())
                .filter((ifsc: string | undefined) => ifsc);
            const { accountNo: targetAccountNo, ifsc: targetIFSC } = newBankDetails;
            if (sourceAccountNos.includes(targetAccountNo)) {
                alert(common.errors.bankErrors.sameBankDetails);
                setNewDetails({
                    ...newBankDetails,
                    accountNo: '',
                    ifsc: '',
                    name: '',
                    branch: '',
                    city: '',
                });
                setCheques(getInitChequeData());
                return;
            }
            const data = targetFunds.map((_ele: ConsolidateTableRowType, index: number) => {
                return {
                    amc: _ele.amc,
                    folio: _ele.folio,
                    bankDetails: newBankDetails,
                };
            });
            try {
                let res = await props.sendPhoneOTP({
                    mobile,
                    pan,
                    pekrn,
                    action: OTP_ACTIONS.updateMultipleBanks,
                });
                props.history.replace('bank-mandate-otp', {
                    data,
                    // images: [cheques.oldCheque, cheques.newCheque],
                    mobile: props.mobile,
                    pan: props.pan,
                    operationType: actionType,
                    addBank,
                    ...(res || {}).body,
                });
            } catch (err: any) {
                alert(err);
            }
        }
    };

    //Save images in store
    useEffect(() => {
        return () => {
            const imageInfo: ImageSaveType = {
                data: [cheques.oldCheque, cheques.newCheque],
                type: 'BANK_MANDATE',
            };
            props.onSaveImageData(imageInfo);
        };
    }, [cheques]);

    const _handleChangeBankDetails = (
        resetValues: boolean = false,
        showModal: boolean = false,
        bankName: string = '',
        bankAddress: string = '',
        city: string = '',
    ) => {
        setShowModal({
            showModal: showModal,
            name: bankName,
            branch: bankAddress,
            city: city,
        });
        if (resetValues) {
            setNewDetails({
                ...newBankDetails,
                name: '',
                branch: '',
                city: '',
            });
        }
    };

    const _getBankDetailsFromIFSC = async (value: string) => {
        if (!!value && value.match(ifscRegex)) {
            setValidation(true);
            setLoader(true);
            const { pan, pekrn, mobile, reqId } = props;
            try {
                let response: any = await props.fetchIFSCDetails({
                    pan,
                    pekrn,
                    mobile,
                    reqId,
                    ifscCode: value,
                });
                const { errors = [], data = [] } = (response || {}).body;
                if (errors.length) {
                    const [firstError] = errors;
                    setNewDetails({
                        ...newBankDetails,
                        name: '',
                        branch: '',
                        city: '',
                    });
                    throw Error(firstError?.message);
                }
                const [details] = data;
                const { BankAdd1 = '', BankAdd2 = '', BankAdd3 = '' } = details;
                _handleChangeBankDetails(
                    false,
                    true,
                    details.BankName,
                    getBankAddress(BankAdd1, BankAdd2, BankAdd3),
                    details.BankCity,
                );
                setValidation(false);
            } catch (e: any) {
                setLoader(false);
                setValidation(false);
                _handleChangeBankDetails(true);
                setErrors({ ifsc: e.message });
            }
        }
    };

    const validateIfscWithRegex = (value: string) => {
        if (!value.match(ifscRegex)) {
            setLoader(false);
            setValidation(false);
            _handleChangeBankDetails(true);
            setErrors({ ifsc: common.errors.bankErrors.ifsc.regex });
        }
    };

    const _handleModalClose = () => {
        setLoader(false);
        setValidation(false);
        setShowModal(false);
        setNewDetails({
            ...newBankDetails,
            ifsc: '',
            name: '',
            branch: '',
            city: '',
        });
    };

    const _getBankInfo = () => {
        const { name = '', branch = '', city = '' } = modalData;
        return [name, branch, city].join(',');
    };

    const _handleProceed = () => {
        const { name = '', branch = '', city = '' } = modalData;
        setNewDetails({
            ...newBankDetails,
            name,
            branch,
            city,
        });
        setShowModal(initialValues);
    };

    return (
        <div className="curved-bg">
            <ActionHeader header={dashboard.BankMandate.BankMandateHeading} />
            <div className="curved-bg-content update-pan-selected-content">
                <div className="curved-bg-content-inner">
                    <div
                        className="curved-bg-content-inner-top"
                        style={{
                            minHeight: 'auto',
                        }}
                    >
                        <p>{dashboard.ChangeBank.selectedFolios.subheading}</p>
                        {bankDetails.map((_ele: BANK_ACCOUNT_DETAILS, ind: number) => (
                            <div className="selected-folios-list">
                                <h3>{_ele.amcName}</h3>
                                <a className="delete-folio">
                                    <img
                                        src="/images/delete-folio.svg"
                                        alt="delete icon"
                                        onClick={() => {
                                            folioRef.current = ind.toString();
                                            setAlertModal({
                                                deleteType: 'deleteFolio',
                                                showModal: true,
                                            });
                                        }}
                                    />
                                </a>
                                <div className="selected-folios-list-bottom">
                                    <p>
                                        {dashboard.ChangeBank.selectedFolios.primaryHolder}
                                        <span>{_ele.primaryHolder}</span>
                                    </p>
                                    <p>
                                        {dashboard.ChangeBank.selectedFolios.ifsc}
                                        <span>{_ele.ifsc || _ele.neftIfsc}</span>
                                    </p>
                                    <p>
                                        {dashboard.ChangeBank.selectedFolios.accountNo}
                                        <span>{_ele.accountNo}</span>
                                    </p>
                                    <p>
                                        {dashboard.ChangeBank.selectedFolios.folioNo}
                                        <span>{_ele.folioNo}</span>
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="add-new-bankAccount">
                        <h4>{dashboard.ChangeBank.selectedFolios.addNewBankHeading}</h4>
                        {/* <p>{dashboard.ChangeBank.selectedFolios.addNewBankHeadingInfo}</p> */}
                        <div className="new-bank-fields">
                            {[
                                {
                                    key: 'accountNo',
                                    label: dashboard.ChangeBank.selectedFolios.fields.accountNumber,
                                    value: newBankDetails.accountNo,
                                    isDisabled: false,
                                    fieldValidation: accountNumberValidation,
                                },
                                {
                                    key: 'ifsc',
                                    label: dashboard.ChangeBank.selectedFolios.fields.ifsc,
                                    value: newBankDetails.ifsc,
                                    isDisabled: false,
                                    blurFunction: validateIfscWithRegex,
                                    shouldValidateField: true,
                                    fieldValidation: validateIfsc,
                                },
                                {
                                    key: 'name',
                                    label: dashboard.ChangeBank.selectedFolios.fields.bankName,
                                    value: newBankDetails.name,
                                    isDisabled: true,
                                },
                                {
                                    key: 'accountType',
                                    label: dashboard.ChangeBank.selectedFolios.fields.accountType,
                                    value:
                                        newBankDetails.accountType ||
                                        dashboard.ChangeBank.selectedFolios.fields.accountType,
                                    isDisabled: true,
                                },
                                {
                                    key: 'branch',
                                    label: dashboard.ChangeBank.selectedFolios.fields.branch,
                                    value: newBankDetails.branch,
                                    isDisabled: true,
                                },
                                {
                                    key: 'city',
                                    label: dashboard.ChangeBank.selectedFolios.fields.city,
                                    value: newBankDetails.city,
                                    isDisabled: true,
                                },
                            ].map((_ele: ACCOUNT_DETAILS) =>
                                _ele.key === 'accountType' ? (
                                    <FormControl variant="outlined" error={!!errors[_ele.key]}>
                                        <Select
                                            labelId="portfolio-sortby-label"
                                            id="portfolio-sortby"
                                            name={'accountType'}
                                            value={_ele.value}
                                            onChange={(e: any) => {
                                                _handleTextInputChange(_ele.key, e.target.value);
                                            }}
                                            // readOnly={true}
                                        >
                                            <MenuItem value={_ele.label}>{_ele.label}</MenuItem>
                                            {ACCOUNT_TYPE_MASTER_DATA.map((type: string) => (
                                                <MenuItem value={type}>{type}</MenuItem>
                                            ))}
                                        </Select>
                                        <FormHelperText
                                            className={!!errors[_ele.key] ? 'error' : ''}
                                        >
                                            {errors[_ele.key]}
                                        </FormHelperText>
                                    </FormControl>
                                ) : (
                                    <FormControl variant="outlined">
                                        <TextInput
                                            variant="outlined"
                                            label={_ele.label}
                                            value={_ele.value.toUpperCase()}
                                            name={_ele.key}
                                            id={_ele.key}
                                            onChange={(e) => {
                                                if (_ele.fieldValidation) {
                                                    _ele.fieldValidation(e.target.value)
                                                        ? _handleTextInputChange(
                                                              _ele.key,
                                                              e.target.value,
                                                          )
                                                        : null;
                                                    return;
                                                }
                                                _handleTextInputChange(_ele.key, e.target.value);
                                            }}
                                            onFocus={() => setErrors({})}
                                            onBlur={() => {
                                                if (_ele.blurFunction) {
                                                    _ele.blurFunction(_ele.value);
                                                }
                                            }}
                                            error={!!errors[_ele.key]}
                                            helperText={errors[_ele.key]}
                                            disabled={_ele.isDisabled}
                                            title={!!_ele.isDisabled ? _ele.value : ''}
                                        />
                                        {_ele.shouldValidateField && showLoader && (
                                            <FormHelperText>
                                                <ValidationUI
                                                    isValidating={ifscValidation}
                                                    onValidationText={common.validatingIFSC}
                                                    successfulValidationText={common.IFSCValidated}
                                                />
                                            </FormHelperText>
                                        )}
                                    </FormControl>
                                ),
                            )}
                        </div>
                    </div>
                    <div className="curved-bg-content-inner-bottom">
                        <h4>{dashboard.ChangeBank.selectedFolios.uploadDocuments}</h4>
                        <p>{dashboard.ChangeBank.selectedFolios.uploadDocumentsInfo}</p>
                        <div className="selected-folios-btn bank-selected-folios-bottom">
                            <div className="change-bank-upload">
                                <div className="change-bank-upload-inner">
                                    <div className="change-bank-upload-single">
                                        <p>{dashboard.ChangeBank.selectedFolios.cancelledCheque}</p>
                                        <div className="bank-selected-upload-fields">
                                            <UploadFile
                                                onImageSelected={(value, format) => {
                                                    setCheques({
                                                        ...cheques,
                                                        oldCheque: {
                                                            ...cheques.oldCheque,
                                                            format: format,
                                                            content: value,
                                                        },
                                                    });
                                                }}
                                                initSelected={
                                                    cheques?.oldCheque?.content &&
                                                    cheques?.oldCheque?.format
                                                }
                                                id={'oldCheque'}
                                            />
                                        </div>
                                    </div>
                                    <div className="change-bank-upload-single">
                                        <p>{dashboard.ChangeBank.selectedFolios.bankCheque}</p>
                                        <div className="bank-selected-upload-fields">
                                            <UploadFile
                                                onImageSelected={(value, format) => {
                                                    setCheques({
                                                        ...cheques,
                                                        newCheque: {
                                                            ...cheques.newCheque,
                                                            format: format,
                                                            content: value,
                                                        },
                                                    });
                                                }}
                                                initSelected={
                                                    cheques?.newCheque?.content &&
                                                    cheques?.newCheque?.format
                                                }
                                                id={'newCheque'}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <FaqLink section={BANK_ACCOUNT_DETAILS} history={props.history} />
                                <Button
                                    className="customBtn"
                                    disabled={
                                        !Object.values(newBankDetails).every((_ele) => !!_ele) ||
                                        !Object.values(cheques).every((_ele: any) => !!_ele.content)
                                    }
                                    onClick={handleSubmit}
                                >
                                    {dashboard.ChangeBank.selectedFolios.buttonText}
                                </Button>
                                <IfscModal
                                    extraClass="ifsc-modal"
                                    showModal={modalData.showModal}
                                    heading={dashboard.UpdateIFSC.noteModals.pleaseConfirm}
                                    info1={'Bank Name'}
                                    info2={'IFSC Code'}
                                    info3={'City'}
                                    info4={'Branch'}
                                    content1={modalData.name}
                                    content2={newBankDetails.ifsc}
                                    content3={modalData.city}
                                    content4={modalData.branch}
                                    proceedBtn={'Okay'}
                                    onProceed={_handleProceed}
                                    cancelBtn={'Cancel'}
                                    onCancel={_handleModalClose}
                                />
                                <NoteModals
                                    showModal={showAlertModal.showModal}
                                    heading={dashboard.noteModals.nctModal.heading}
                                    info={
                                        showAlertModal.deleteType === 'deletedAllFolios'
                                            ? dashboard.noteModals.bankMandate.info
                                            : dashboard.ChangeTaxStatus.noteModals.confirmationText
                                    }
                                    proceedBtn={
                                        showAlertModal.deleteType === 'deletedAllFolios'
                                            ? dashboard.noteModals.okayTxt
                                            : dashboard.noteModals.otpModal.proceedText
                                    }
                                    cancelBtn={
                                        showAlertModal.deleteType === 'deletedAllFolios'
                                            ? ''
                                            : dashboard.noteModals.otpModal.cancelText
                                    }
                                    onProceed={
                                        showAlertModal.deleteType === 'deletedAllFolios'
                                            ? () => props.history.replace('bank-mandate')
                                            : handleRemoveBankDetails
                                    }
                                    onCancel={() => {
                                        setAlertModal({
                                            deleteType: '',
                                            showModal: false,
                                        });
                                        folioRef.current = '';
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default connect(({ authReducer }: RootStateType) => ({ ...authReducer }), {
    sendPhoneOTP,
    fetchIFSCDetails,
    onSaveImageData,
})(BankMandateAddBank);
